(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerInner = document.querySelector('.header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      if (this.headerIsAlwaysSticky) this.reveal;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
        this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-always-sticky');
      }

      if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('shopify-section-header-sticky');
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (this.disclosures) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }
      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      if (this.disclosureLists) {
        this.disclosureLists.forEach((disclosureList) => {
          disclosureList.setAttribute('hidden', true);
        });
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      popupSliderInit(false, this);
      const popupElement = this.querySelector('.js-popup-slider');
      const activeMedia = this.querySelector(`[data-media-id="${opener.getAttribute('data-media-id')}"]`);
      const activeSlide = activeMedia?.closest('.swiper-slide');
      const activeIndex = Array.from(popupElement?.querySelectorAll('.swiper-wrapper > .swiper-slide') || []).indexOf(activeSlide);
      if (activeIndex >= 0) popupElement.swiper?.slideTo(activeIndex, 0);
      this.showActiveMedia();
      // Refresh the focus boundary after Swiper adds its navigation controls.
      trapFocus(this, this.querySelector('[role="dialog"]'));
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vzp-parteneri"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(R){
if(!R||R.dataset.vzpReady==='true')return;
R.dataset.vzpReady='true';
var RM=window.matchMedia&&matchMedia("(prefers-reduced-motion:reduce)").matches;
if(R.classList)R.classList.add("anim");
setTimeout(function(){(R.querySelectorAll?R.querySelectorAll(".rv"):[]).forEach(function(e){e.classList.add("in")});if(!("IntersectionObserver" in window)){R.querySelectorAll(".count").forEach(function(e){e.textContent=e.dataset.to+(e.dataset.suf||"")})}},2200);
if('IntersectionObserver' in window){const io=new IntersectionObserver((es)=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}}),{threshold:.12});
R.querySelectorAll('.rv').forEach(el=>io.observe(el));
const cio=new IntersectionObserver((es)=>es.forEach(e=>{
if(!e.isIntersecting)return;
const el=e.target,to=+el.dataset.to,suf=el.dataset.suf||'';let n=0;if(RM){el.textContent=to+suf;cio.unobserve(el);return;}
const step=Math.max(1,Math.round(to/40));
const t=setInterval(()=>{n+=step;if(n>=to){n=to;clearInterval(t)}el.textContent=n+suf},22);
cio.unobserve(el);
}),{threshold:.6});
R.querySelectorAll('.count').forEach(el=>cio.observe(el));}
const sales=R.querySelector('[data-vzp="sales"]'),aov=R.querySelector('[data-vzp="aov"]');
const lSales=R.querySelector('[data-vzp="sales-label"]'),lAov=R.querySelector('[data-vzp="aov-label"]');
const oTier=R.querySelector('[data-vzp="tier"]'),oMonth=R.querySelector('[data-vzp="month"]'),oYear=R.querySelector('[data-vzp="year"]');
function tierOf(s){if(s<=50)return{n:'Starter',r:.03};if(s<=100)return{n:'Pro',r:.05};return{n:'Elite',r:.07}}
function fmt(v){return Math.round(v).toLocaleString('ro-RO')+' lei'}
function calc(){
const s=+sales.value,a=+aov.value,t=tierOf(s);
lSales.textContent=s+(s===1?' comandă':' comenzi');
lAov.textContent=a+' lei';
const net=a*0.95;
const month=Math.round(s*net*t.r);
oTier.textContent='Nivel '+t.n+' • '+Math.round(t.r*100)+'%';if(oTier.parentElement)oTier.parentElement.className='out tier-'+t.n.toLowerCase();
oMonth.textContent=fmt(month);
oYear.textContent=fmt(month*12);
}
if(sales&&aov&&lSales&&lAov&&oTier&&oMonth&&oYear){sales.addEventListener('input',calc);aov.addEventListener('input',calc);calc();}
R.querySelectorAll('.qa .a').forEach(function(a){a.setAttribute('aria-hidden','true')});
R.querySelectorAll('.qa .q').forEach(q=>q.addEventListener('click',()=>{
const qa=q.parentElement,a=qa.querySelector('.a'),open=qa.classList.contains('open');
R.querySelectorAll('.qa').forEach(x=>{x.classList.remove('open');x.querySelector('.a').style.maxHeight=null;x.querySelector('.a').setAttribute('aria-hidden','true')});
R.querySelectorAll('.qa .q').forEach(function(x){x.setAttribute('aria-expanded','false')});if(!open){qa.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';a.setAttribute('aria-hidden','false');q.setAttribute('aria-expanded','true')}
}));
 var resizeFaq=function(){R.querySelectorAll('.qa.open .a').forEach(function(a){a.style.maxHeight=a.scrollHeight+'px'})};
 window.addEventListener('resize',resizeFaq,{passive:true});
 R.vzpCleanup=function(){window.removeEventListener('resize',resizeFaq)};
 }
 function scopeMobileChatTeaser(){
 if(location.pathname.replace(/\/+$/,'')!=='/pages/parteneri')return true;
 var host=document.querySelector('#smart-bot-container');
 if(!host||!host.shadowRoot)return false;
 var root=host.shadowRoot;
 function ensureChatStyle(){
 if(root.querySelector('#vzp-mobile-chat-scope'))return;
 var style=document.createElement('style');
 style.id='vzp-mobile-chat-scope';
 style.textContent='@media(max-width:600px){[class*="_notification-card_"]{display:none!important}}';
 root.appendChild(style);
 }
 ensureChatStyle();
 if(!host.vzpChatObserver){
 host.vzpChatObserver=new MutationObserver(ensureChatStyle);
 host.vzpChatObserver.observe(root,{childList:true});
 }
 return true;
 }
 var chatAttempts=0,chatTimer=setInterval(function(){chatAttempts+=1;scopeMobileChatTeaser();if(chatAttempts>=60)clearInterval(chatTimer)},500);
 scopeMobileChatTeaser();
 document.querySelectorAll('.vzp').forEach(init);
 document.addEventListener('shopify:section:load',function(e){var root=e.target.querySelector('.vzp');if(root)init(root)});
 document.addEventListener('shopify:section:unload',function(e){var root=e.target.querySelector('.vzp');if(root&&root.vzpCleanup)root.vzpCleanup()});
 })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vzy-home-media-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vzy-bf-rolling')) {
  customElements.define('vzy-bf-rolling', class extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._visible = false;
      this._words = Array.from(this.children);
      this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._sync = () => this.syncAnimation();
      this._motion.addEventListener('change', this._sync);
      document.addEventListener('visibilitychange', this._sync);
      document.addEventListener('DOMContentLoaded', this._sync);
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(entries => {
          this._visible = entries[0].isIntersecting;
          this.syncAnimation();
        });
        this._observer.observe(this);
      }
    }

    syncAnimation() {
      if (!this._connected) return;
      if (this._motion.matches) {
        this.stopAnimation();
        return;
      }
      if (!this._visible || document.hidden) {
        if (this._timeline) this._timeline.pause();
        return;
      }
      if (!window.gsap || this._words.length < 2) return;
      if (!this._timeline) {
        const words = this._words;
        window.gsap.set(words, { yPercent: 100 });
        window.gsap.set(words[0], { yPercent: 0 });
        this.setAttribute('data-rolling-active', '');
        this._timeline = window.gsap.timeline({ repeat: -1, paused: true });
        words.forEach((word, index) => {
          const next = words[(index + 1) % words.length];
          this._timeline
            .to(word, { yPercent: -100, duration: 0.45, ease: 'power2.inOut' }, '+=2')
            .fromTo(next, { yPercent: 100 }, { yPercent: 0, duration: 0.45, ease: 'power2.inOut', immediateRender: false }, '<')
            .set(word, { yPercent: 100 });
        });
      }
      this._timeline.play();
    }

    stopAnimation() {
      if (this._timeline) this._timeline.kill();
      this._timeline = null;
      if (window.gsap && this._words) window.gsap.set(this._words, { clearProps: 'transform' });
      this.removeAttribute('data-rolling-active');
    }

    disconnectedCallback() {
      this._connected = false;
      this.stopAnimation();
      if (this._observer) this._observer.disconnect();
      if (this._motion) this._motion.removeEventListener('change', this._sync);
      document.removeEventListener('visibilitychange', this._sync);
      document.removeEventListener('DOMContentLoaded', this._sync);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vzy-returns-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const form = document.getElementById('VzyReturnForm');
    if (!form) return;

    const submittedAt = document.getElementById('VzyReturn-submitted-at');
    form.addEventListener('submit', () => {
      if (submittedAt) submittedAt.value = new Date().toISOString();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
